/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusInvoiceOptionsDto
 */
export interface NovitusInvoiceOptionsDto {
    /**
     * Pomiń opis słowny kwoty do zapłaty.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    skip_description_value_to_pay?: boolean;
    /**
     * Pomiń blok kwot brutto w rozliczeniu podatku.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    skip_block_gross_value_in_accounting_tax?: boolean;
    /**
     * Pogrubiona etykieta 'Nabywca'.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    buyer_bold?: boolean;
    /**
     * Pogrubiona etykieta 'Sprzedawca'.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    seller_bold?: boolean;
    /**
     * Pogrubiony nr NIP nabywcy.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    buyer_nip_bold?: boolean;
    /**
     * Pogrubiony nr NIP sprzedawcy.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    seller_nip_bold?: boolean;
    /**
     * Drukuj etykietę 'opis/symbol' w nagłówku, przed pozycjami faktury.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    print_label_description_symbol_in_invoice_header?: boolean;
    /**
     * Drukuj numer porządkowy w pozycji faktury.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    print_position_number_invoice?: boolean;
    /**
     * Etykieta "Do zapłaty" przed blokiem rozliczenia podatków.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    to_pay_label_before_acounting_tax_block?: boolean;
    /**
     * Drukuj ilość groszy w postaci słownej.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    print_cents_in_words?: boolean;
    /**
     * Nie drukuj daty sprzedaży jeżeli jest taka sama jak data wystawienia faktury.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    dont_print_sell_date_if_equal_create_date?: boolean;
    /**
     * Nie drukuj danych sprzedawcy w nagłówku.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    dont_print_seller_data_in_header?: boolean;
    /**
     * Nie drukuj opisów do pozycji.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    dont_print_sell_items_description?: boolean;
    /**
     * Włączona obsługa płatności.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    enable_payment_form?: boolean;
    /**
     * Nie drukuj danych odbiorcy (nie obejmuje pola z nr nip, regon lub pesel).
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    dont_print_customer_data?: boolean;
    /**
     * Drukuj napis zapłacono gotówką.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    print_payd_in_cash?: boolean;
    /**
     * Pomiń etykietę 'Sprzedawca'.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    skip_seller_label?: boolean;
    /**
     * Drukuj etykietę 'FAKTURA VAT'.
     * @type {boolean}
     * @memberof NovitusInvoiceOptionsDto
     */
    print_invoice_tax_label?: boolean;
}

/**
 * Check if a given object implements the NovitusInvoiceOptionsDto interface.
 */
export function instanceOfNovitusInvoiceOptionsDto(value: object): value is NovitusInvoiceOptionsDto {
    return true;
}

export function NovitusInvoiceOptionsDtoFromJSON(json: any): NovitusInvoiceOptionsDto {
    return NovitusInvoiceOptionsDtoFromJSONTyped(json, false);
}

export function NovitusInvoiceOptionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusInvoiceOptionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'skip_description_value_to_pay': json['skip_description_value_to_pay'] == null ? undefined : json['skip_description_value_to_pay'],
        'skip_block_gross_value_in_accounting_tax': json['skip_block_gross_value_in_accounting_tax'] == null ? undefined : json['skip_block_gross_value_in_accounting_tax'],
        'buyer_bold': json['buyer_bold'] == null ? undefined : json['buyer_bold'],
        'seller_bold': json['seller_bold'] == null ? undefined : json['seller_bold'],
        'buyer_nip_bold': json['buyer_nip_bold'] == null ? undefined : json['buyer_nip_bold'],
        'seller_nip_bold': json['seller_nip_bold'] == null ? undefined : json['seller_nip_bold'],
        'print_label_description_symbol_in_invoice_header': json['print_label_description_symbol_in_invoice_header'] == null ? undefined : json['print_label_description_symbol_in_invoice_header'],
        'print_position_number_invoice': json['print_position_number_invoice'] == null ? undefined : json['print_position_number_invoice'],
        'to_pay_label_before_acounting_tax_block': json['to_pay_label_before_acounting_tax_block'] == null ? undefined : json['to_pay_label_before_acounting_tax_block'],
        'print_cents_in_words': json['print_cents_in_words'] == null ? undefined : json['print_cents_in_words'],
        'dont_print_sell_date_if_equal_create_date': json['dont_print_sell_date_if_equal_create_date'] == null ? undefined : json['dont_print_sell_date_if_equal_create_date'],
        'dont_print_seller_data_in_header': json['dont_print_seller_data_in_header'] == null ? undefined : json['dont_print_seller_data_in_header'],
        'dont_print_sell_items_description': json['dont_print_sell_items_description'] == null ? undefined : json['dont_print_sell_items_description'],
        'enable_payment_form': json['enable_payment_form'] == null ? undefined : json['enable_payment_form'],
        'dont_print_customer_data': json['dont_print_customer_data'] == null ? undefined : json['dont_print_customer_data'],
        'print_payd_in_cash': json['print_payd_in_cash'] == null ? undefined : json['print_payd_in_cash'],
        'skip_seller_label': json['skip_seller_label'] == null ? undefined : json['skip_seller_label'],
        'print_invoice_tax_label': json['print_invoice_tax_label'] == null ? undefined : json['print_invoice_tax_label'],
    };
}

export function NovitusInvoiceOptionsDtoToJSON(value?: NovitusInvoiceOptionsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'skip_description_value_to_pay': value['skip_description_value_to_pay'],
        'skip_block_gross_value_in_accounting_tax': value['skip_block_gross_value_in_accounting_tax'],
        'buyer_bold': value['buyer_bold'],
        'seller_bold': value['seller_bold'],
        'buyer_nip_bold': value['buyer_nip_bold'],
        'seller_nip_bold': value['seller_nip_bold'],
        'print_label_description_symbol_in_invoice_header': value['print_label_description_symbol_in_invoice_header'],
        'print_position_number_invoice': value['print_position_number_invoice'],
        'to_pay_label_before_acounting_tax_block': value['to_pay_label_before_acounting_tax_block'],
        'print_cents_in_words': value['print_cents_in_words'],
        'dont_print_sell_date_if_equal_create_date': value['dont_print_sell_date_if_equal_create_date'],
        'dont_print_seller_data_in_header': value['dont_print_seller_data_in_header'],
        'dont_print_sell_items_description': value['dont_print_sell_items_description'],
        'enable_payment_form': value['enable_payment_form'],
        'dont_print_customer_data': value['dont_print_customer_data'],
        'print_payd_in_cash': value['print_payd_in_cash'],
        'skip_seller_label': value['skip_seller_label'],
        'print_invoice_tax_label': value['print_invoice_tax_label'],
    };
}

